import React from "react";
function Footer() {
    return (
        <div className="footer">
            <h4>Credit-Go</h4>
            <ul>
                <li>Partners</li>
                <li>Org</li>
                <li>Products</li>
                <li></li>

            </ul>


            <ul>
                <li>Partners</li>
                <li>Org</li>
                <li>Products</li>
                <li></li>
            </ul> <ul>
                <li>Partners</li>
                <li>Org</li>
                <li>Products</li>

            </ul>
            <p className='copy'>all Rights Reserved @2022 made With  by <a href='/'>OrangeDEVS</a></p>
        </div>
    )
}
export default Footer;